import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62c34592"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Exercise", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("A watcher watches whether a value gets changed and enables us to trigger actions depending on the value's changes. In this case the button click triggers a change of the orderStatus. And the watcher runs a setTimeout function, whenever orderStatus is changed. Resetting "),
  /*#__PURE__*/_createElementVNode("code", null, "orderStatus"),
  /*#__PURE__*/_createTextVNode(" leads to the bug that the message from "),
  /*#__PURE__*/_createElementVNode("code", null, "orderSubmitted"),
  /*#__PURE__*/_createTextVNode(" shows up again. This happens because the watcher only checks whether the value changes and not what the value actually is.")
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Reset button is pretty useless because reset function is triggered by watcher anyways", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" reset ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const orderStatus = ref('Where is my taco?');
const orderSubmitted = ref('');
const count = ref(0);

const getTaco = () => {
      orderStatus.value = 'Here it comes!'
      count.value++;
    };

const reset = () => {
      orderStatus.value = 'Order another one'
    };

watch(orderStatus, async (newValue, oldValue) => {
  if(orderStatus.value === 'Order another one') {return}

  orderSubmitted.value = 'Your order was submitted';
  setTimeout(() => {
    orderSubmitted.value = '';
    reset()
  }, 1000);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("p", null, [
      _createElementVNode("code", null, " orderStatus = " + _toDisplayString(orderStatus.value), 1)
    ]),
    _createElementVNode("button", { onClick: getTaco }, " Click me to order a taco "),
    _createElementVNode("h3", null, _toDisplayString(orderStatus.value), 1),
    (orderSubmitted.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(orderSubmitted.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, "You have ordered " + _toDisplayString(count.value) + " tacos.", 1),
    _createElementVNode("button", { onClick: reset }, _hoisted_6)
  ]))
}
}

})